<template>
  <b-modal ref="invalidateDocumentModal" :no-close-on-backdrop="noCloseOnBackdrop" :no-close-on-esc="noCloseOnEsc" size="lg" hide-footer hide-header>
    <div class="modal-content-box">
      <b-form @submit.prevent="yesAction">
        <b-container fluid>
          <b-row>
            <b-col>
              <p class="title">
                Are you sure you want to invalidate this document?
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <p class="para">
                Invalidating will nullify the entire document. <br />
                A record of the invalidation will be recorded within the document log.
              </p>
            </b-col>
          </b-row>
          <b-row class="text-center">
            <b-col>
              <button-cmp @click="hide" aria-label="no" class="btn-modal button-cancel">Cancel</button-cmp>
            </b-col>
            <b-col class="p-0">
              <p>
                <button-cmp aria-label="yes" type="submit" class="btn-modal button-invalidate">Yes, Invalidate Document</button-cmp>
              </p>
            </b-col>
          </b-row>
        </b-container>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
import ButtonCmp from "@/components/common/button";

export default {
  name: "invalidate-document-modal",
  components: { ButtonCmp },
  data() {
    return {
      noCloseOnBackdrop: true,
      noCloseOnEsc: true
    };
  },
  props: {},
  methods: {
    show() {
      this.$refs.invalidateDocumentModal.show();
    },
    hide() {
      this.$refs.invalidateDocumentModal.hide();
    },
    yesAction() {
      this.$emit("invalidDocument");
      this.hide();
    }
  }
};
</script>

<style scoped lang="scss">
.modal-content-box {
  padding: 32px 16px 39px;
  border-radius: 3px;
  text-align: center;

  .title {
    font-size: 18px;
    font-weight: bold;
    color: #666669;
  }
  .para {
    font-size: 14px;
    color: #666669;
    font-weight: normal;
    padding: 10px 0 20px;
    max-width: 100%;
  }
}

.btn-modal {
  border-radius: 18px;
  font-size: 14px;
  font-weight: normal;
  width: 100%;
  text-transform: none;
  letter-spacing: normal;
}

.button-cancel {
  background-color: #e0e0e0;
  color: #4a4a4a;
}

.button-invalidate {
  color: #fff;
  background-color: #f16559;
}
</style>
